import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/settings/returns")({
  beforeLoad: ({ location }) => {
    throw redirect({
      href: location.href.replace(/^\/settings\/returns/, "/settings/demand"),
      replace: true,
    })
  },
})
